/* eslint-disable no-param-reassign */

import { createSlice } from "@reduxjs/toolkit";

import { initialize } from "../../actions";

const initialState = {
  agentImageSrc: null,
  agentName: null,
  agentTitle: null,
  brokerage: null,
  isPro: false
};

const agentSlice = createSlice({
  name: "agent",
  initialState,
  extraReducers: {
    [initialize]: (state, action) => {
      state.agentImageSrc = action.payload.agentImageSrc;
      state.agentName = action.payload.agentName;
      state.agentTitle = action.payload.agentTitle;
      state.brokerage = action.payload.brokerage;
      state.isPro = action.payload.isPro;
    }
  }
});

export default agentSlice.reducer;
